/**
 * Route names differ between API Gateway (/welds) and CloudFront/dev (/weld-summary).
 */
export function getWeldIqPaths() {
  const style = process.env.REACT_APP_WELDIQ_API_PATH_STYLE || 'cloudfront';
  if (style === 'gateway') {
    return {
      health: 'health',
      welds: 'welds',
      anomalies: 'anomalies',
      anomalySummary: 'anomaly-summary',
      compliance: 'compliance',
      pipeline: 'pipeline',
      anomaliesCheck: 'anomalies/check',
      indicationsCheck: 'indications/check',
      predict: 'predict',
      realtimeScorePass: 'realtime/score-pass',
      inspectionJobs: 'inspection/jobs',
      inspectionWelds: 'inspection/welds',
    };
  }
  return {
    health: 'health',
    welds: 'weld-summary',
    anomalies: 'anomaly-query',
    anomalySummary: 'anomaly-summary',
    compliance: 'wps-compliance',
    pipeline: 'pipeline-trigger',
    anomaliesCheck: 'anomalies/check',
    indicationsCheck: 'indications/check',
    predict: 'predict',
    realtimeScorePass: 'realtime/score-pass',
    inspectionJobs: 'inspection/jobs',
    inspectionWelds: 'inspection/welds',
  };
}
